//------------------------------------------------------------------------------
// タイトル付きエリア
//------------------------------------------------------------------------------
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';

// TODO 空白調整 & プロパティ化
function TitledArea({
  sx,
  title,
  children,
}) {
  return (
    <Card
      sx={{
        px: 0, py: 0,
        boxShadow: 'none',
        ...sx,
      }}
    >
      <CardHeader
        title={title}
        sx={{
          px: 0, py: 2,
        }}
        titleTypographyProps={{
          fontSize: 'h6.fontSize',
        }}
      />
      <CardContent
        sx={{
          px: 1, pt: 0, pb: 0,
          '&:last-child': {
            pb: 1,
          }
        }}
      >
        {children} 
      </CardContent>
    </Card>
  );
}

// デフォルトエクスポート
export default TitledArea;
